import { Box, TableContainer } from "@material-ui/core";
import { FC, useEffect, useMemo, useState } from "react";
import { useStyles } from "./styles";
import FleetReportsTable from "./FleetReportsTable";
import { useTableSync } from "hooks/useTableSync";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { getVisibleFleetReportRows } from "hooks/useFleetReports";
import PaginationSwitch from "componentsNew/elements/PaginationSwitch";

interface PropsType {}

const FleetReportsContainers: FC<PropsType> = () => {
  const classes = useStyles();
  const { t1Ref, t2Ref } = useTableSync();
  const { fleetReportList, offBoardedFleetReportList, fleetReportFilters } = useTypeSelectors(
    (state) => state.fleetReports,
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const totalCount = useMemo(() => {
    const { offBoardedRows, actualRows } = getVisibleFleetReportRows(
      fleetReportList,
      offBoardedFleetReportList,
      fleetReportFilters,
    );
    return offBoardedRows.length + actualRows.length;
  }, [fleetReportList, offBoardedFleetReportList, fleetReportFilters]);

  useEffect(() => {
    setPage(0);
  }, [
    fleetReportFilters.search,
    fleetReportFilters.company,
    fleetReportFilters.invoice,
    fleetReportFilters.statuses,
    fleetReportFilters.ordering,
    fleetReportFilters.showActual,
    fleetReportFilters.month,
  ]);

  const handleChangePage = (_event: unknown, value: number) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <>
      <Box style={{display: "flex"}}>
        <TableContainer className={classes.tableContainer} ref={t1Ref} key="fleetreportscontainer1">
          <FleetReportsTable isFixed page={page} rowsPerPage={rowsPerPage} />
        </TableContainer>
        <TableContainer
          className={classes.tableContainer2}
          ref={t2Ref}
          key="fleetreportscontainer2"
        >
          <FleetReportsTable page={page} rowsPerPage={rowsPerPage} />
        </TableContainer>
      </Box>
      <Box className={classes.tableFooter}>
        <PaginationSwitch
          page={page}
          rowsPerPage={rowsPerPage}
          totalPages={totalCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePage}
        />
      </Box>
    </>
  );
};

export default FleetReportsContainers;
